import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import Service from "@/services/AsesmenKeperawatanIntensif";
import { isEmpty } from "lodash";

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "asesmen-keperawatan-intensif"
})
class AsesmenKeperawatanIntensifStore extends VuexModule {
  loading = false;
  asesmen: any = null;

  @Mutation
  SET_ASESMEN(val) {
    this.asesmen = val;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  CLEAR_STORE() {
    this.asesmen = null;
  }

  @Action({ rawError: true })
  async getByRegister(registerId): Promise<void> {
    this.SET_LOADING(true);

    const response = await Service.getByRegister(registerId).finally(() => {
      this.SET_LOADING(false);
    });

    const list = response?.data?.data ?? response?.data ?? [];
    const data = Array.isArray(list) && list.length > 0 ? list[0] : null;

    this.SET_ASESMEN(isEmpty(data) ? null : data);
  }

  @Action({ rawError: true })
  clear(): void {
    this.CLEAR_STORE();
  }
}

export default getModule(AsesmenKeperawatanIntensifStore);
